import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const LABEL_BG = '#542376';
const LABEL_BG_FROM = '#2b2b79';
const LABEL_BG_TO = '#7e1b72';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2px 4px 2px 4px;
  height: 37px;
  background-color: ${LABEL_BG};
  background-image: linear-gradient(to right, ${LABEL_BG_FROM}, ${LABEL_BG_TO});
  text-align: center;
  justify-content: center;
  
  ${({
    theme
  }) => css`
    color: ${theme.colors.shades[7]};
  `};
`;

const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 12px;
`;

const Subtitle = styled.div`
  font-size: 11px;
`;

/**
 * @tags styled, label
 */
function Label(props) {
  return (
    <Wrapper className={props.className} data-qa={props.qa}>
      <Title>{props.title}</Title>
      {props.subTitle &&
        <Subtitle>{props.subTitle}</Subtitle>}
    </Wrapper>
  );
}

Label.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  qa: PropTypes.string
};

Label.defaultProps = {
  className: undefined,
  subTitle: '',
  qa: undefined
};

Label.displayName = 'Label';

/** @component */
export default Label;
